var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStringIcon = function SvgStringIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 132.292 132.292",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeDasharray: "none",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 5.501,
    transform: "translate(.047 .012)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.215,
    height: 27.215,
    x: 52.491,
    y: 52.527,
    strokeLinecap: "square",
    rx: 6.876,
    ry: 6.876
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.215,
    height: 27.215,
    x: 2.984,
    y: 52.527,
    strokeLinecap: "square",
    rx: 6.876,
    ry: 6.876
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.215,
    height: 27.215,
    x: 101.998,
    y: 52.527,
    strokeLinecap: "square",
    rx: 6.876,
    ry: 6.876
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    d: "M30.262 66.134h22.435"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    d: "M79.769 66.134h22.435"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStringIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/string-icon.3147dc19b37019f14530a7d78192c7be.svg";